import { caching } from '@/common/cache.dict.js';
import { boundApiRequest } from '@/restapi/restapi.base.js';

const doRequest = boundApiRequest('/api/role/');


/**
 * Запросить все роли
 */
async function _rolesAll() {
    const { result } = await doRequest('all', {}, {
      messages:false
    });
    return result;
}

export const rolesAll = caching(_rolesAll);
